export const buyerConfigDev = {
  apiKey: "AIzaSyD00en1eXBL-kvuQ95kbC3vSVWh15AKrhk",
  authDomain: "qarabao-buyer-login.firebaseapp.com",
  databaseURL: "https://qarabao-buyer-login.firebaseio.com",
  projectId: "qarabao-buyer-login",
  storageBucket: "qarabao-buyer-login.appspot.com",
  messagingSenderId: "506180705472"
}

export const buyerConfigProd = {
  apiKey: "AIzaSyDD6QgV2d5eYI9Sn4saWQKtqBVcKpQswEI",
  authDomain: "qarabao-customer.firebaseapp.com",
  databaseURL: "https://qarabao-customer.firebaseio.com",
  projectId: "qarabao-customer",
  storageBucket: "qarabao-customer.appspot.com",
  messagingSenderId: "757844990010"
}
